  import React,{useEffect} from "react";

import Navbar from "../components/Navbar/Navbar";
  import UpcomingProjects from "../components/UpcomingProjects";
  import Footer from "../components/Footer/Footer";

  const AllProjects = () => {
        useEffect(() => {
          window.scrollTo(0, 0);
        }, []);
    return (
      <>
        <Navbar />
        <UpcomingProjects /> {/* show ALL projects */}
        <Footer />
      </>
    );
  };

  export default AllProjects;
                